import { styled } from '@/stitches.config';
import { Card } from '@base-app';

export const StyledCard = styled(Card, { padding: '$8', boxShadow: '$chart' });
